// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1RfXX","colMin":"styles_colMin__3a3PX","colCheckbox":"styles_colCheckbox__1_Ptk"};